/**
 * Shared question / answer helpers for SLC and project surveys.
 * Re-exports the canonical implementations from slide-level classification
 * so callers import from `pages/projects/questions` without duplicating logic.
 */

export {
    SLIDE_LEVEL_FREE_TEXT_CATEGORY_ID as FREE_TEXT_CATEGORY_ID,
    SLIDE_LEVEL_NONE_CATEGORY_ID as NONE_CATEGORY_ID,
    SLIDE_LEVEL_FREE_TEXT_CATEGORY_ID,
    SLIDE_LEVEL_NONE_CATEGORY_ID,
    DEFAULT_NONE_CATEGORY_LABEL,
    DEFAULT_FREE_TEXT_OPTION_LABEL,
    DEFAULT_SLIDE_LEVEL_QUESTION as DEFAULT_QUESTION,
    getFreeTextOptionLabelForDisplay,
    normalizeOneQuestion,
    createDefaultQuestion,
    getEffectiveCategoriesForAnnotator,
    getAnswerCategoryIds,
    getAnswerCategoryLabels,
    toggleMultiCategorySelection,
    getQuestionDisplayName,
    normalizeStoredAnswer,
    ensureMultiOtherIdForLegacyFreeText,
    buildStoredAnswerPayload,
    isQuestionAnswerComplete,
    getUnansweredQuestionLabels,
    countAnsweredQuestions,
    getFeaturedQuestionIndex,
    formatAnswerSummary,
    normalizeFreeTextSettings,
    shouldUseInlineChoices,
    getQuestionSelectableChoiceCount,
    SLC_MAX_INLINE_CHOICES,
} from '../uis/SlideLevelClassificationUI/slideLevelClassificationModel';
